<template>
  <modal :title="$t('product.description')">
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div class="product--details" v-html="htmlContent"></div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal';
import { mapState } from 'pinia';
import { useProductInfoStore } from '@/store-pinia/product-info';

export default {
  name: 'ProductInfo',
  components: {
    Modal
  },
  computed: {
    ...mapState(useProductInfoStore, ['htmlContent'])
  }
};
</script>
